import { InjectionToken, Provider } from '@angular/core';

export interface KillerWebSocketConfig {
  endpoint: string;
}

const DEFAULT_CONFIG: KillerWebSocketConfig = {
  // TODO: A sensible default - maybe localhost?
  endpoint: '',
};

export const KILLER_WEB_SOCKET_CONFIG =
  new InjectionToken<KillerWebSocketConfig>('KILLER_WEB_SOCKET_CONFIG', {
    providedIn: 'root',
    factory: () => DEFAULT_CONFIG,
  });

export function provideKillerWebSocketConfig(
  config: Partial<KillerWebSocketConfig>,
): Provider {
  return {
    provide: KILLER_WEB_SOCKET_CONFIG,
    useValue: {
      ...DEFAULT_CONFIG,
      ...config,
    },
  };
}
